/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SelectCMACoverImageDto
 */
export interface SelectCMACoverImageDto {
    /**
     * 
     * @type {number}
     * @memberof SelectCMACoverImageDto
     */
    properyImageId: number;
}

/**
 * Check if a given object implements the SelectCMACoverImageDto interface.
 */
export function instanceOfSelectCMACoverImageDto(value: object): value is SelectCMACoverImageDto {
    if (!('properyImageId' in value) || value['properyImageId'] === undefined) return false;
    return true;
}

export function SelectCMACoverImageDtoFromJSON(json: any): SelectCMACoverImageDto {
    return SelectCMACoverImageDtoFromJSONTyped(json, false);
}

export function SelectCMACoverImageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectCMACoverImageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'properyImageId': json['properyImageId'],
    };
}

export function SelectCMACoverImageDtoToJSON(json: any): SelectCMACoverImageDto {
    return SelectCMACoverImageDtoToJSONTyped(json, false);
}

export function SelectCMACoverImageDtoToJSONTyped(value?: SelectCMACoverImageDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'properyImageId': value['properyImageId'],
    };
}

